<template>
  <v-container>
    <v-row>
      <v-col>
        <TabComponent
          name="manufacturingStep"
          :tabs="tabs"
          :nodeId="nodeId" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref } from "vue";
import { useTranslation } from "i18next-vue";

import ProcessData from "./FormParts/ProcessData.vue";
import CostBreakdownTab from "@/views/Calculations/shared/CostBreakdownTab.vue";
import WorkSystem from "./ViewParts/WorkSystem.vue";
import DirectLabour from "./ViewParts/DirectLabour.vue";
import Setup from "./ViewParts/Setup.vue";
import ToolsAndFixtures from "./ViewParts/ToolsAndFixtures.vue";
import RisidualManufacturingOverhead from "./ViewParts/RisidualManufacturingOverhead.vue";
import ManufacturingScrap from "./ViewParts/ManufacturingScrap.vue";

import TabComponent from "@/components/Elements/TabComponent.vue";

const { t } = useTranslation();
const tab = ref("basicData");

defineProps({
  nodeId: {
    type: String,
    required: true
  }
});

const tabs = [
  {
    value: "processData",
    icon: "mdi-pencil",
    component: ProcessData
  },
  {
    value: "workSystem",
    icon: "mdi-eye",
    component: WorkSystem
  },
  {
    value: "directLabour",
    icon: "mdi-eye",
    component: DirectLabour
  },
  {
    value: "setup",
    icon: "mdi-eye",
    component: Setup
  },
  {
    value: "toolsAndFixtures",
    icon: "mdi-eye",
    component: ToolsAndFixtures
  },
  {
    value: "risidualManufacturingOverhead",
    icon: "mdi-eye",
    component: RisidualManufacturingOverhead
  },
  {
    value: "manufacturingScrap",
    icon: "mdi-eye",
    component: ManufacturingScrap
  },
  {
    value: "costBreakdown",
    icon: "mdi-eye",
    component: CostBreakdownTab,
    containerStyle: "overflow-x: auto;"
  }
];
</script>

<style>
.smaller-tabs span.v-btn__prepend {
  margin-inline: 0 !important;
}

.smaller-tabs .v-tab {
  padding: 0 0.3rem !important;
}
</style>
